import { set as setCookie } from 'js-cookie'

import { AuthResponse }      from '../api/index'
import { credentialsCookie } from '../config'

export default (authentication: AuthResponse) => {
  setCookie(
    credentialsCookie.name,
    JSON.stringify(authentication),
    {
      expires: credentialsCookie.expirationInDays
    },
  )

  window.location.reload()
}



// WEBPACK FOOTER //
// ./src/project-utils/hard-login.ts